import React, { useEffect, useRef, useState } from 'react'
import CustomTitle from '../../../components/UI/title/CustomTitle'
import { useDispatch, useSelector } from 'react-redux';
import useMixpanel from '../../../hooks/useMixpanel';
import { setButtonBackClick, setButtonBackIsShow, setButtonClick } from '../../../store/buttonSlice';
import axios from 'axios';

export default function EnterCode({ setPageComponent, inputEmail, setCode, code, error, setButtonStatus, setError, setButtonText }) {



    const inputRefs = useRef([]);

    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').trim().slice(0, 6);
        if (pastedData.length === inputRefs.current.length) {

            const splitData = pastedData.split('');
            setCode(splitData);
            const lastInputField = inputRefs.current[inputRefs.current.length - 1];
            if (lastInputField) {
                lastInputField.focus();
            }
        }
    };

    const handleChangeCode = (e, index) => {
        const newCode = [...code];
        const { value } = e.target;

        if (value === '' && newCode[index] === '' && index > 0) {
            inputRefs.current[index - 1].focus();
        }

        newCode[index] = value.toUpperCase().replace(/[^A-Z0-9]/g, '') || '';
        setCode(newCode);

        if (value && index < inputRefs.current.length - 1) {
            inputRefs.current[index + 1].focus();
        }

    };

    const handleKeyDown = (index) => (e) => {
        if (e.key === 'Backspace' && !code[index] && index > 0) {
            const newCode = [...code];
            newCode[index - 1] = '';
            setCode(newCode);
            inputRefs.current[index - 1].focus();
        }
    };


    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const dispatch = useDispatch();
    const { trackP1Event } = useMixpanel();
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$/i;
    const isFormComplete = () => {
        return code.every(digit => digit.trim() !== '');
    };

    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        trackP1Event('web_forgot_code_view', {
        });
        dispatch(setButtonBackIsShow(true));
        setError(false)
        setCode(['', '', '', '', '', '']);
    }, [])

    const [wrongCode, setWrongCode] = useState(false);
    const [noCode, setNoCode] = useState(false);

    useEffect(() => {
        setButtonText('Continue');
        if (buttonClicked) {

            if (isFormComplete()) {
                setButtonStatus('load');
                verifyCode(code.join(''))
            } else {
                setNoCode(true);
                setError(true)
                setErrorMessage('Please enter all digits');

            }
            setTimeout(() => {
                dispatch(setButtonClick(false));
            }, 100);
        }

    }, [buttonClicked]);


    const verifyCode = (passwordCode) => {
        const data = {
            email: inputEmail,
            "code": passwordCode,
        };

        axios.post("https://staging.zeely.link/users/verify-code", data, {
            headers: {
                "Content-Type": "application/json"
            },
            redirect: 'follow'
        })
            .then(response => {
                console.log(response)
                if (response.data.statusCode === 400 && response.data.message === 'Wrong email verification code provided') {
                    setError(true)
                    setButtonStatus('');
                    setErrorMessage('Sorry, you entered the wrong code. Please try again.');
                    trackP1Event('web_click_entercode', {
                        confirm_success: "FALSE",
                        error_reason: [
                            wrongCode && "wrong_code",
                            noCode && "no_code"
                        ].filter(Boolean).join(",") || "none"
                    })
                } else {
                    setButtonStatus('');
                    setPageComponent('newPassword');
                    trackP1Event('web_click_entercode', {
                        confirm_success: "TRUE",
                        error_reason: [
                            noCode && "no_code"
                        ].filter(Boolean).join(",") || "none"
                    })
                }
            })
            .catch(error => {
                setButtonStatus('');
                setError(true);
                setErrorMessage('Sorry, you entered the wrong code. Please try again.');
                // setTimeout(() => {
                //     setError(false);
                // }, 1000);
            });
    };

    const buttonBackClicked = useSelector((state) => state.button.buttonBackClicked);
    useEffect(() => {
        if (buttonBackClicked) {
            setTimeout(() => {
                dispatch(setButtonBackClick(false));
                setPageComponent('confirmForgetEmail');
            }, 100);
        }
    }, [buttonBackClicked]);

    return (
        <div style={{ paddingBottom: '36rem' }}>
            <CustomTitle style={{ marginBottom: "24rem" }} title={'Enter your code'} />
            <p className="text" style={{ marginTop: "-12rem", marginBottom: '24rem', }}>
                We've sent you a 6-digit code to {inputEmail}
            </p>
            <div className="code-inputs">
                {code.map((digit, index) => (
                    <input
                        key={index}
                        type="tel"
                        maxLength="1"
                        value={digit}
                        onKeyDown={() => { handleKeyDown(index); }}
                        onChange={(e) => { handleChangeCode(e, index); setError(false); }}
                        onPaste={handlePaste}
                        ref={(el) => inputRefs.current[index] = el}
                        className={`code-input ${error ? 'error' : ''}`}
                        onFocus={() => trackP1Event('web_forgot_code_input', {

                        })}
                    />
                ))}
            </div>
            {error && (
                <div className="error-text">
                    {errorMessage}
                </div>
            )}

        </div>
    )
}
